import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWhitelabels } from "../Redux/Action";
import { initializeWhitelabelBranding } from "./dynamicBranding";

export const useInitializeWhitelabel = () => {
  const dispatch = useDispatch();
  const whitelabelData = useSelector((state) => state?.GetWhitelabel?.whitelabelDataWithID);
  const whitelabelLoading = useSelector((state) => state?.GetWhitelabel?.loading);

  useEffect(() => {
    const domain = new URL(window.location.href).origin;
    dispatch(
      getWhitelabels({
        payload: domain
      })
    );
  }, [dispatch]);

  // Apply whitelabel branding when data is available
  useEffect(() => {
    initializeWhitelabelBranding(whitelabelData);
  }, [whitelabelData]);

  return {
    whitelabelData,
    loading: whitelabelLoading
  };
};